import React from 'react';
import { Pivot, PivotItem } from '@fluentui/react';
import { UserGuideType } from "../../GlobalConst/globalEnums";
import { addPivotItemKeyToUrl, getPivotItemKeyFromUrl } from '../../helpers/HelperMethods';
import UserGuide from './UserGuide';

const UserGuidesTabs = ({ parentPivotKey, adminEditMode }) => {

    const defaultSelectedKey = getPivotItemKeyFromUrl('SP', parentPivotKey);

    return (
        <div>
            <Pivot styles={pivotStyles} defaultSelectedKey={defaultSelectedKey} onLinkClick={addPivotItemKeyToUrl(parentPivotKey)}>
                <PivotItem itemKey='SP' headerText='SharePoint/Teams'>
                    <UserGuide adminEditMode={adminEditMode} userGuideType={UserGuideType.sharepoint}/>
                </PivotItem>
                <PivotItem itemKey='PP' headerText='Power Platform'>
                    <UserGuide adminEditMode={adminEditMode} userGuideType={UserGuideType.powerPlatform}/>
                </PivotItem>
            </Pivot>
        </div>
    );

}

const pivotStyles = {
    root: {
        marginBottom: 20,
        textAlign: 'center'
    },
    linkContent: {
        fontSize: 16,
    }
}

export default UserGuidesTabs


// WEBPACK FOOTER //
// ./src/components/Settings/UserGuidesTabs.js